const e = {
  fileExplorer: {
    title: "Upload Files",
    fileSectionTitle: "Files",
    loadMore: "Load more",
    emptyState: {
      description: "Looks like you haven’t uploaded any files yet.",
      browseButton: "Browse files"
    },
    fileInput: {
      dragDrop: "Drag and drop file(s) here",
      clickBrowse: "or click to browse files"
    },
    actions: {
      delete: "Delete",
      deleteConfirm: "Are you sure? This will permanently delete the file and cannot be undone.",
      copyLink: "Copy link",
      rename: "Rename",
      download: "Download",
      view: "View"
    }
  }
};
export {
  e as defaultCopies
};
